import React from 'react';
import { Lock, CheckCircle2, History } from 'lucide-react';

export const ComplianceDashboardPage: React.FC = () => {
  return (
    <div className="space-y-6 max-w-6xl mx-auto">
      <div className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
        <h1 className="text-xl font-bold text-slate-900 flex items-center gap-2">
          <Lock className="w-5 h-5 text-sky-600" />
          Global Compliance & Audit
        </h1>
        <p className="text-xs text-slate-500 mt-1">
          Zero raw PII persistence, statutory audit trails, and privacy compliance.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="p-5 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-2">
          <span className="text-xs font-semibold text-slate-500 uppercase font-mono">GDPR Status</span>
          <div className="text-xl font-bold text-emerald-700 flex items-center gap-1.5">
            <CheckCircle2 className="w-5 h-5 text-emerald-600" /> 100% Compliant
          </div>
          <p className="text-[11px] text-slate-400">EU Regulation 2016/679</p>
        </div>

        <div className="p-5 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-2">
          <span className="text-xs font-semibold text-slate-500 uppercase font-mono">PDPL Status</span>
          <div className="text-xl font-bold text-emerald-700 flex items-center gap-1.5">
            <CheckCircle2 className="w-5 h-5 text-emerald-600" /> 100% Compliant
          </div>
          <p className="text-[11px] text-slate-400">Regional Privacy Standard</p>
        </div>

        <div className="p-5 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-2">
          <span className="text-xs font-semibold text-slate-500 uppercase font-mono">Purged Artifacts</span>
          <div className="text-xl font-bold text-sky-700">100% Purged</div>
          <p className="text-[11px] text-slate-400">Zero raw text logging</p>
        </div>

        <div className="p-5 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-2">
          <span className="text-xs font-semibold text-slate-500 uppercase font-mono">Active Regions</span>
          <div className="text-xl font-bold text-slate-900">47 States</div>
          <p className="text-[11px] text-slate-400">Global Coverage</p>
        </div>
      </div>

      <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm space-y-4">
        <h2 className="text-base font-bold text-slate-900 flex items-center gap-2">
          <History className="w-4 h-4 text-sky-600" />
          Statutory Audit Standard
        </h2>
        <p className="text-xs text-slate-600 leading-relaxed">
          Every document processed generates an immutable audit record capturing tenant ID, AI model latency, checksum results, and redaction coordinates.
        </p>

        <div className="p-4 rounded-xl bg-slate-50 border border-slate-200 font-mono text-xs text-slate-800 space-y-1">
          <div className="text-emerald-700 font-semibold">[SYSTEM AUDIT EVENT LOG: ACTIVE]</div>
          <div>Tenant: tenant-default-001 | User: dev.mohammadii@gmail.com</div>
          <div>Action: DOCUMENT_PROCESSED_NATIVE_NESTJS | Latency: 412ms</div>
          <div>Redaction Mode: BLACK_BOX | PII Items Redacted: 4</div>
          <div>Checksum Validation: LUHN (VALID) | ICAO_MRZ (VALID) | MODULO_11 (VALID)</div>
        </div>
      </div>
    </div>
  );
};

